import { useQuery } from '@apollo/client';
import GetBuildWithAIRevisionAsync from './GetBuildWithAIRevisionAsync.graphql';
/**
 * GraphQL query operation to get an asynchronously generated Build with AI
 * survey revision.
 */
const useGetBuildWithAIRevisionAsync = (predictionId, options = {}) => useQuery(GetBuildWithAIRevisionAsync, Object.assign({
  variables: {
    predictionId: predictionId !== null && predictionId !== void 0 ? predictionId : 'PREDICTION_ID_NOT_SPECIFIED'
  },
  skip: !predictionId
}, options));
export default useGetBuildWithAIRevisionAsync;